var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrLead = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0E2933",
  d: "M3.5 12.389a6.26 6.26 0 0 1 4.417-1.833c.76.001 1.506.14 2.204.404l-.453 1.311a4.86 4.86 0 0 0-6.612 4.535.694.694 0 0 1-1.39 0A6.26 6.26 0 0 1 3.5 12.39M7.917 9.167a4.166 4.166 0 1 0 0-8.333 4.166 4.166 0 0 0 0 8.333m0-6.945a2.778 2.778 0 1 1 0 5.556 2.778 2.778 0 0 1 0-5.556"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#0E2933",
  strokeWidth: 1.36,
  d: "M10.726 10.049a.54.54 0 0 1 .417-.883h5.698a.54.54 0 0 1 .417.882l-2.2 2.687v2.952a.54.54 0 0 1-.919.384l-1.217-1.2v-2.155z"
})));
export { SvgFiRrLead as ReactComponent };
export default __webpack_public_path__ + "42a79b9fb78159b0afb436c1a8419040.svg";